
<template >
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7','padding-bottom':'50px'}" id="outermost">

        <van-nav-bar
            title="完成整改"
            left-text="返回"
            left-arrow
            @click-left="$router.back()"
            id="topbar"
        />
        <van-form>
          <div style="padding:20px;">

                <div class="infoTit">整改信息</div>
                <div class="topDiv">
                    <van-cell-group>
                        <van-field label="整改备注" readonly type="textarea" v-model="problem.rectificationRemark" input-align="right" placeholder="点击输入整改备注"/>
                    </van-cell-group>
                    <van-cell-group>
                        <van-field name="uploader" label="整改照片" input-align="right">
                          <template #input>
                            <van-row type="flex" style="flex-flowp:row wrap;">
                              <van-col span='11' v-for="(photoIds,i) in rectificationPhotoIds" :key="i" style="margin-top:5px;margin-right:10px;">
                                <img style="height:80px;width:100%;" :src="apiUrl + 'download/' + photoIds" @click="showRectificationPhotos(rectificationPhotoIds,i)"/>
                              </van-col>
                            </van-row>
                          </template>
                        </van-field>
                    </van-cell-group>
                </div>

          </div>
          <div style="position: fixed;bottom: 0px;width: 100%;">
              <van-button block color="#1B75F6" native-type="button" @click="$router.back()">关闭</van-button>
          </div>
      </van-form>
  </div>
</template>

<script>
    import Setting from '@/setting';
    import Vue from 'vue';
    import { ImagePreview } from 'vant';

    Vue.use(ImagePreview);
    export default {
        name: 'project-completeProblem',
        data () {
            return {
                clientHeight: window.screen.height,
                problem: {
                    rectificationRemark: '',
                    rectificationPhotos: ''
                },
                rectificationPhotoIds: [],
                apiUrl: Setting.apiBaseURL
            }
        },

        methods: {
            showRectificationPhotos (ids, index) {
                var imageArr = [];
                ids.forEach(id => {
                    imageArr.push(Setting.apiBaseURL + 'download/' + id);
                });
                ImagePreview({
                    images: imageArr,
                    startPosition: index,
                    closeable: true
                });
            }
        },
        mounted () {
            this.problem = this.$route.params.problem;
            if (this.problem.rectificationRemark === null) {
                this.problem.rectificationRemark = '';
            }
            var ids = this.problem.rectificationPhotos;
            this.rectificationPhotoIds = ids.split(',');
        }
    }
</script>

<style lang="less" scoped>
    .topDiv{
        margin-top:30px;
        padding:20px;
        background-color: #FFFFFF;
    }
    .infoTit{
      color:#242E42;
      font-size: 30px;
      font-weight: bold;
    }

</style>
